import { useEffect, useState } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

import { DefaultSortTypesEnum, OptionKey } from '@/common/types';

const RESET_PAGE_VALUE = 1;

const useListPagination = () => {
  const {
    page, setPage, setPerPage, perPage,
    currentSearch, searchString, setSearchString,
  } = usePaginationParams();

  const [sortBy, setSortBy] = useState<OptionKey>(DefaultSortTypesEnum.ASC);

  useEffect(() => {
    setPage(RESET_PAGE_VALUE);
  }, [setPage, currentSearch]);

  return {
    page,
    setPage,
    perPage,
    setPerPage,
    searchString,
    currentSearch,
    setSearchString,

    sortBy,
    setSortBy,
  };
};

export default useListPagination;
